import React, { PropTypes } from 'react'
import MultiLangText from '../multilang/MultiLangText'

class Person extends React.Component {



  constructor(){
    super();

    this.state = {
      emailWidth :'0px'
    }

    this.mouseOver = this.mouseOver.bind(this)
    this.mouseOut = this.mouseOut.bind(this)
  }



  mouseOver(){

    (this.props.details.email)&&
    this.setState({emailWidth:this.refs.innerEmailWidth.offsetWidth+5+'px'})

  }

  mouseOut(){
    (this.props.details.email)&&
    this.setState({emailWidth:'0px'})
  }


  render(){

  //console.log("Person",this.props);

  let photoStyle = {
    backgroundImage : `url(${this.props.photo.url})`
  }

  let photoStyleMonotone = {
      backgroundImage : `url(${this.props.photo_monotone.url})`
  }

  //console.log("Person this.props",this.props);

  return (
      <div className="person" onMouseOver={this.mouseOver} onMouseOut={this.mouseOut}>
          <div className="background">
            <div className="photo monotone" style={photoStyleMonotone}></div>
            <div className="photo clear" style={photoStyle}></div>
          </div>
          <div className="text-container">
            <div className="inner">
                <div className="title"><MultiLangText text={this.props.details.title_text} /> </div>
                <h4 className="name" dangerouslySetInnerHTML={{__html:this.props.details.name}} />

                {(this.props.details.email)?
                    <div className="email"><h6><a href={`mailto:${this.props.details.email}`}><span className="arrow">&lt;</span><span className={"inner-email"} style={{width:this.state.emailWidth}} ref="innerEmail"><MultiLangText text={this.props.optionsData.data.email_me} /></span><span className="arrow">&gt;</span></a></h6></div>
                 :
                  <div className="email"><h6>&nbsp;</h6></div>
               }
          </div>

            {(this.props.details.email)?
                <span className={"email-width-setter email"} ref="innerEmailWidth"><MultiLangText text={this.props.optionsData.data.email_me} /></span>
            : null }

          </div>


      </div>
    )
  }
}

export default Person



// WEBPACK FOOTER //
// ./src/modules/offices/Person.js